import React from 'react';

import styled from 'styled-components';

const StyledInput = styled.input`
    border: solid 1px;
    border-color: ${(props) =>
        props.invalid ? props.theme.color.warning : '#3c3f41'};
    width: 100%;
    border-radius: 4px;
    padding: 0.5em 1em;
    color: ${(props) => props.theme.color.navigationColor};
`;

function TextInput(props) {
    return <StyledInput type="text" {...props} />;
}

export default TextInput;
